/** Shared class for all filter inputs — rounded corners, brand focus ring */
export const FILTER_INPUT_CLASS =
  'input-clean text-sm py-2 sm:py-2.5';

export const FILTER_LABEL_CLASS =
  'block text-xs sm:text-sm font-medium text-secondary mb-1.5 sm:mb-2';

export const FILTER_PANEL_CLASS =
  'bg-white p-4 sm:p-5 rounded-card shadow-card mb-4 sm:mb-6 border border-gray-100';
